<template>
  <section>
    <transition name="bounce" enter-active-class="slideInUp" leave-active-class="slideOutDown">
      <div class="section-login-alert text-center" v-if="message">
        <div class="box-login-alert" @click="setMessage(null)">{{ message }}</div>
      </div>
    </transition>
  </section>
</template>

<script>
  export default {
    data () {
      return {
        message: null
      }
    },
    methods: {
      setMessage (message) {
        this.message = message
        if (message) {
          setTimeout(() => {
            this.message = null
          }, 10000)
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/login/LoginAlert.vue